var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expande-horizontal pa-3 wrap centraliza",staticStyle:{"height":"36vh"}},[_c('img',{staticStyle:{"width":"100px"},attrs:{"src":"img/empty.gif","alt":"empty"}}),_c('span',{staticClass:"px-3 fonte-italica fonte grey--text text-center"},[_vm._v(" Não encontramos nenhum registro, clique no botão abaixo e cadastre um! ")])])
}]

export { render, staticRenderFns }